<template>
  <div class="emApp" :class="{ mobile }">
    <header>
      <nav class="header-nav">
        <div class="left-panel">
          <router-link :to="{ name: 'index' }">
            <img src="@/assets/img/logo.png" />
          </router-link>
        </div>
        <div class="right-panel">
          <el-dropdown @command="handleLanguageCommand">
            <div class="link language">
              <el-icon>
                <em-icon-language />
              </el-icon>
              <span>{{ (LANGUAGE[$event.Language] || {}).name }}</span>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="it in $event.Versions" :key="it.ID" :command="it.ID">{{ (LANGUAGE[it.Language] || {}).name }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </nav>
    </header>
    <main>
      <div v-if="!$event.EventName.includes('远毅')"  class="left-nav" :class="{ 'is--show': menu }">
        <ul>
          <template v-for="it in menus" :key="it.name">
            <li
              v-if="it.name == 'personalcenter-personal' || it.name == 'personalcenter-confirmation' || steps.findIndex((x) => x.Link.toLocaleLowerCase() === 'tickettype.aspx') >= 0"
              :class="{ 'is-active': it.name == currentRoute }"


            >
              <router-link :to="{ name: it.name }">
                <el-icon v-if="it.icon">
                  <component :is="it.icon" />
                </el-icon>
                {{ $t(`personalcenter.menu.${it.title}`) }}
              </router-link>
            </li>
          </template>
          <li>
            <router-link :to="{ name: 'confirmation', query: { uid: '' } }">
              <el-icon><Menu /></el-icon>
              {{ $t(`personalcenter.menu.back`) }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="right-content">
        <div class="mobile-nav">
          <div class="mobile-btn">
            <el-button type="primary" circle @click="menu = !menu">
              <em-icon-menu />
              <span>{{ ['菜单', 'Menu'][$language] }}</span>
            </el-button>
          </div>
        </div>
        <section @click="menu = false">
          <router-view />
        </section>
      </div>
    </main>
    <footer></footer>
  </div>
</template>
<script setup>
  import { useEventListener } from '@vueuse/core'
  import { LANGUAGE } from '@/config'
  import { useAppStore } from '@/store/modules/app'
  import { storeToRefs } from 'pinia'
  import { useRouter, useRoute } from 'vue-router'

  import { Menu } from '@element-plus/icons-vue'
  import { ref, inject, onMounted, provide, watch,computed } from 'vue'
  import { getSteps } from '@/api/config'

  const steps = ref([])

  onMounted(async () => {
    const { data } = await getSteps()
    steps.value = data
  })

  provide('$steps', steps)
  const $language = inject('$language')
  const mobile = ref(false)
  const route = useRoute()
  const menu = ref(false)

  console.log('route', route)

  const $event = inject('$event')
  const router = useRouter()

  const resizeBody = () => {
    mobile.value = document.body.getBoundingClientRect().width - 1 < 900
    console.log('resizeBody', mobile.value)
  }

  resizeBody()
  const cleanup = useEventListener('resize', () => {
    resizeBody()
  })

  const { loadConfig } = useAppStore()

  const handleLanguageCommand = (cmd) => {
    location.href = `./#/personalcenter?v=${cmd}`
    location.reload()
  }
const menus=computed(()=>{
  if($event?.Config?.HideBuyAgain===true){
    
return [
    {
      name: 'personalcenter-personal',
      title: 'personal',
      icon: 'em-icon-menu-personal',
    },
    {
      name: 'personalcenter-confirmation',
      title: 'confirmation',
      icon: 'em-icon-menu-confirmation',
    },

    {
      name: 'personalcenter-order',
      title: 'order',
      icon: 'em-icon-menu-order',
    },
  ]
  }
return [
    {
      name: 'personalcenter-personal',
      title: 'personal',
      icon: 'em-icon-menu-personal',
    },
    {
      name: 'personalcenter-confirmation',
      title: 'confirmation',
      icon: 'em-icon-menu-confirmation',
    },
    {
      name: 'personalcenter-ticket',
      title: 'buy',
      icon: 'em-icon-menu-buy',
    },
    {
      name: 'personalcenter-order',
      title: 'order',
      icon: 'em-icon-menu-order',
    },
  ]
})

  const currentRoute = ref('personalcenter-personal')

  watch(
    () => route.name,
    (val) => {
      console.log('route', val)
      currentRoute.value = val
      if (val === 'personalcenter-colleague') {
        currentRoute.value = 'personalcenter-ticket'
      }
      menu.value = false
    },
    {
      immediate: true,
    }
  )
</script>

<style lang="scss" scoped>
  .emApp {
    header {
      width: 100%;
      background: #353b55;
      color: #fff;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2000;
      padding: 0 24px;
      box-sizing: border-box;
      .header-nav {
        margin: 0 auto;
        height: 68px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left-panel {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img {
            height: 24px;
          }
        }

        .right-panel {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
    main {
      width: 100%;
      margin: 0 auto;
      padding-top: 68px;
      display: flex;
      height: 100vh;
      box-sizing: border-box;
      .left-nav {
        flex: 0 0 220px;
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        box-shadow: 0px 2px 12px rgba(53, 59, 85, 0.12);
        background-color: #fff;
        padding: 16px 16px;
        ul,
        li {
          padding: 0;
          margin: 0;
          list-style: none;
        }
        li {
          height: 45px;
          line-height: 45px;

          padding: 0 13px;
          cursor: pointer;
          margin-bottom: 3px;
          span {
            margin-left: 10px;
          }
          svg {
            :deep() {
              path {
                stroke: #000;
              }
            }
          }
          a {
            color: #000;
            text-decoration: none;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
          &.is-active,
          &:hover {
            background: var(--el-color-primary);
            border-radius: 8px;
            color: #fff;
            a {
              color: #fff;
            }
            svg {
              :deep() {
                path {
                  stroke: #fff;
                }
              }
            }
          }
        }
      }
      .right-content {
        flex: 1;
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        section {
          flex: 1;
          height: 100%;
          overflow: hidden;
          box-sizing: border-box;
        }
        .mobile-nav {
          display: none;
        }
      }
    }
  }
  @media screen and (max-width: 760px) {
    .emApp {
      header {
        padding: 0 12px;
        .header-nav {
          justify-content: space-between;
          position: relative;
          padding: 0 0;
          .left-panel {
            display: flex;
            height: 68px;
            img {
              height: 22px;
            }
            a {
              height: 68px;

              display: flex;
              justify-content: flex-start;
              align-items: center;
            }
          }
        }
      }

      .left-nav {
        display: none;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        width: calc(100vw - 48px);
        max-width: 300px;
        z-index: 9999;
        &.is--show {
          display: block;
        }
      }
      main {
        .right-content .mobile-nav {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 12px;
          .mobile-btn {
            // position: absolute;
            // left: -24px;
            .el-button {
              border-radius: 6px;
              margin-right: 20px;
              width: auto;
              background-color: #5573ed;
              border-width: 0;
              color: var(--el-color-white);
              font-size:16px;
              svg {
                padding-right: 6px;
                width:18px;
                width:18px;
                :deep() {
                  path {
                    fill: var(--el-color-white);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .link {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    > .el-icon {
      font-size: 24px;
      margin-right: 8px;
    }
    > span {
      color: #fff;
      font-size: 14px;
    }
    &.language {
      > .el-icon {
        font-size: 24px;
        margin-right: 4px;
      }
    }
  }
  .el-divider {
    margin: 0 20px;
  }
</style>
